"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createLoggerAndReturnStream = exports.createLogger = void 0;
var browser_core_1 = require("@datadog/browser-core");
var pino_1 = __importDefault(require("pino"));
var pino_datadog_1 = __importDefault(require("pino-datadog"));
var pino_wrap_1 = require("./pino-wrap");
function _createLogger(_a) {
    var name = _a.name, logLevel = _a.logLevel, environment = _a.environment, datadogApiKey = _a.datadogApiKey, browserLogger = _a.browserLogger, returnStream = _a.returnStream, version = _a.version;
    var stream = process.stdout;
    if (!browserLogger && ['preview', 'test', 'production'].includes(environment)) {
        stream = pino_datadog_1["default"].createWriteStreamSync({
            service: name,
            apiKey: datadogApiKey,
            ddsource: 'nodejs',
            ddtags: "env:".concat(environment, ",version:").concat(version),
            keepMsg: true
        });
    }
    var options = __assign({ name: name, level: logLevel, serializers: {
            req: pino_1["default"].stdSerializers.req,
            res: pino_1["default"].stdSerializers.res,
            err: pino_1["default"].stdSerializers.err,
            error: pino_1["default"].stdSerializers.err
        }, mixin: function (mergeObject) {
            // Remap err object to `error` - as Datadog expects error
            // Could add `errorKey` to options, but wasn't working
            // Datadog expects `error` key, not `err`
            // @ts-ignore
            if ('err' in mergeObject && mergeObject.err instanceof Error) {
                // @ts-ignore
                return { error: mergeObject.err };
            }
            return {};
        }, mixinMergeStrategy: function (mergeObject, mixinObject) {
            var result = __assign(__assign({}, mergeObject), mixinObject);
            if (result.error) {
                // @ts-ignore
                result.error.stack = (0, browser_core_1.toStackTraceString)((0, browser_core_1.computeStackTrace)(result.error));
            }
            return result;
        } }, (environment === 'development' && {
        transport: {
            target: 'pino-pretty',
            options: {
                colorize: true
            }
        }
    }));
    if (browserLogger) {
        options.browser = {
            serialize: true,
            write: {
                info: function (_a) {
                    var msg = _a.msg, level = _a.level, rest = __rest(_a, ["msg", "level"]);
                    browserLogger.info(msg || '', rest);
                },
                error: function (_a) {
                    var _b, _c;
                    var msg = _a.msg, level = _a.level, rest = __rest(_a, ["msg", "level"]);
                    var args = __assign({}, rest);
                    if (rest.error) {
                        var error = rest.error;
                        error.type = (_b = error.type) !== null && _b !== void 0 ? _b : 'Error';
                        error.stack = (0, browser_core_1.toStackTraceString)((0, browser_core_1.computeStackTrace)(error));
                        args.error = error;
                    }
                    else if (rest.err) {
                        var error = rest.err;
                        error.type = (_c = error.type) !== null && _c !== void 0 ? _c : 'Error';
                        error.stack = (0, browser_core_1.toStackTraceString)((0, browser_core_1.computeStackTrace)(error));
                        delete args.err;
                        args.error = error;
                    }
                    browserLogger.error(msg || '', args);
                },
                warn: function (_a) {
                    var msg = _a.msg, level = _a.level, rest = __rest(_a, ["msg", "level"]);
                    browserLogger.warn(msg || '', rest);
                },
                debug: function (_a) {
                    var msg = _a.msg, level = _a.level, rest = __rest(_a, ["msg", "level"]);
                    browserLogger.debug(msg || '', rest);
                }
            }
        };
    }
    var logger = (0, pino_wrap_1.wrap)((0, pino_1["default"])(options, stream));
    if (returnStream) {
        return [logger, stream];
    }
    return logger;
}
function createLogger(options) {
    return _createLogger(__assign(__assign({}, options), { returnStream: false }));
}
exports.createLogger = createLogger;
function createLoggerAndReturnStream(options) {
    return _createLogger(__assign(__assign({}, options), { returnStream: true }));
}
exports.createLoggerAndReturnStream = createLoggerAndReturnStream;
